import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforcorporateeverts() {

const cardData = {
keyword: "Urbania Hire for Corporate Events in Pune",
headingDescription: "Urbania Hire for Corporate Events in Pune is a convenient travel solution for companies planning conferences, team outings, business meetings, corporate functions, employee gatherings, and group events. Ruturaj Enterprises provides comfortable Urbania vehicles with professional drivers, spacious seating, air conditioning, and suitable arrangements for local and outstation corporate travel. From office staff pickup and event transportation to airport transfers and group journeys, the service is designed to make corporate movement organized, comfortable, and dependable.",
topPlaces: [
{
title: "Hinjewadi IT Park",
description: "Hinjewadi IT Park is a major corporate destination in Pune where Urbania vehicles are useful for employee transportation, business meetings, company events, conferences, and group movements. A spacious Urbania can accommodate corporate teams comfortably while reducing the need to coordinate several smaller cars."
},
{
title: "Kharadi EON IT Park",
description: "Kharadi EON IT Park attracts employees, business visitors, and corporate groups throughout the year. Urbania hire here can support staff pickup and drop services, corporate event travel, client transportation, and organized group journeys with comfortable seating and professional driving assistance."
},
{
title: "Magarpatta City",
description: "Magarpatta City is a prominent business and residential hub suitable for corporate transportation requirements. Urbania vehicles can be arranged for office teams, company functions, employee gatherings, business travel, and group transfers between workplaces, hotels, railway stations, and event venues."
},
{
title: "Pune International Airport",
description: "Corporate groups arriving or departing through Pune International Airport can use Urbania transportation for convenient airport transfers. The larger vehicle format is particularly useful when employees, guests, or business delegates are travelling together with luggage and require coordinated pickup and drop arrangements."
},
{
title: "Baner",
description: "Baner has numerous offices, hotels, restaurants, event venues, and business establishments, making it a practical location for corporate group transportation. An Urbania can provide comfortable movement for teams attending meetings, seminars, company celebrations, conferences, and professional events."
},
{
title: "Viman Nagar",
description: "Viman Nagar is well connected with Pune Airport, business districts, hotels, and commercial establishments. Corporate Urbania hire in this area can be useful for airport transfers, employee transportation, guest movement, business events, and coordinated travel for larger office groups."
},
{
title: "Pimpri Chinchwad",
description: "Pimpri Chinchwad has a strong industrial and corporate presence, creating demand for reliable group transportation. Urbania vehicles can be arranged for employee travel, corporate functions, factory visits, meetings, conferences, and group transfers between PCMC locations and Pune."
},
{
title: "Koregaon Park",
description: "Koregaon Park is surrounded by hotels, restaurants, commercial establishments, and venues frequently used for professional gatherings. Corporate Urbania services can help transport employees, clients, delegates, and event groups between accommodation, offices, meeting venues, and other important Pune locations."
},
{
title: "Wakad",
description: "Wakad provides convenient connectivity between Pune, Pimpri Chinchwad, Hinjewadi, and major residential areas. Urbania hire from Wakad can support corporate team travel, employee pickup and drop, business events, office functions, and outstation group journeys with ample passenger space."
},
{
title: "Pune Railway Station",
description: "Pune Railway Station is an important arrival and departure point for corporate visitors and travelling teams. A hired Urbania can provide coordinated transfers for employees, business delegates, event participants, and corporate groups travelling between the railway station, offices, hotels, and event venues."
}
],
services: [
{
name: "Urbania on Rent for Corporate Travel Pune",
description: "Urbania on Rent for Corporate Travel Pune is suitable for companies arranging comfortable transportation for employees, managers, clients, and business delegates. Spacious seating, air conditioning, luggage capacity, and professional driver support make it practical for meetings, office visits, conferences, and longer corporate journeys."
},
{
name: "Urbania for Corporate Office Staff Pickup Pune",
description: "Urbania for Corporate Office Staff Pickup Pune provides a spacious transportation option for teams travelling together from residential areas to offices and business parks. It can help companies coordinate employee movement efficiently while giving passengers a comfortable and organized journey."
},
{
name: "Urbania Traveller for Corporate Events Pune",
description: "Urbania Traveller for Corporate Events Pune is designed for employee gatherings, seminars, conferences, annual functions, team activities, and company celebrations. The larger seating capacity allows groups to travel together while reducing the need for multiple individual vehicles."
},
{
name: "Corporate Event Urbania Hire Pune",
description: "Corporate Event Urbania Hire Pune offers practical group transportation for business functions, corporate meetings, conferences, exhibitions, workshops, and employee events. Vehicles can be arranged according to the event schedule with professional driver assistance for convenient transfers."
},
{
name: "Urbania for Corporate Group Travel Pune",
description: "Urbania for Corporate Group Travel Pune is suitable when employees, business partners, or corporate guests need to travel together. The spacious cabin provides comfortable seating for group journeys within Pune as well as longer intercity and outstation corporate trips."
},
{
name: "Luxury Urbania on Rent for Events Pune",
description: "Luxury Urbania on Rent for Events Pune offers a premium and comfortable travel option for corporate functions, executive gatherings, business events, conferences, and special company programs. Its spacious interior and professional chauffeur support help create a more organized group travel experience."
},
{
name: "13 Seater Urbania on Rent in Pune",
description: "13 Seater Urbania on Rent in Pune is a convenient choice for corporate teams, event groups, families, and organized travel parties. The vehicle provides comfortable seating and sufficient space for group movement, making it useful for local programs, meetings, events, and outstation journeys."
},
{
name: "13 Seater Urbania Traveller Pune",
description: "13 Seater Urbania Traveller Pune is suitable for companies and groups looking for comfortable transportation with a dedicated driver. It can be used for corporate events, employee travel, business meetings, airport transfers, group tours, and longer journeys from Pune to nearby destinations."
},
{
name: "13 Seater Urbania Hire in Pune",
description: "13 Seater Urbania Hire in Pune provides flexible group transportation for corporate programs, staff movement, family travel, events, and outstation trips. The spacious vehicle helps passengers travel together comfortably while simplifying coordination for the trip organizer."
},
{
name: "13 Seater Urbania Booking Pune",
description: "13 Seater Urbania Booking Pune is useful for organizations and groups planning transportation in advance for events, conferences, office travel, airport transfers, and tours. Advance arrangements can help coordinate vehicle availability, pickup locations, travel schedules, and destination requirements."
},
{
name: "13 Seater Urbania Van on Rent Pune13 Seater Urbania for Outstation Pune",
description: "13 Seater Urbania Van on Rent Pune13 Seater Urbania for Outstation Pune is suitable for groups planning longer journeys from Pune. The spacious vehicle can support comfortable intercity travel for corporate teams, family groups, event participants, and organized tours with professional driver assistance."
},
{
name: "13 Seater Urbania on Rent Near Me Pune",
description: "13 Seater Urbania on Rent Near Me Pune is intended for customers searching for a convenient group vehicle close to their preferred pickup point. It can be arranged for corporate events, office travel, family trips, airport transfers, local programs, and outstation journeys."
},
{
name: "13 Seater Luxury Urbania Rental Pune",
description: "13 Seater Luxury Urbania Rental Pune provides a spacious and premium travel option for corporate groups and special occasions. It is suitable for executive travel, company events, conferences, business outings, guest transportation, and organized group journeys where comfort and convenience are important."
},
{
name: "13 Seater Urbania for Family Trip Pune",
description: "13 Seater Urbania for Family Trip Pune is a practical option for families travelling together from Pune to tourist destinations, weddings, functions, religious places, and holiday locations. A single spacious vehicle makes group coordination easier and provides comfortable seating throughout the journey."
},
{
name: "13 Seater Urbania for Group Travel Pune",
description: "13 Seater Urbania for Group Travel Pune is suitable for friends, families, corporate teams, event participants, and tour groups. With spacious seating and driver assistance, it can be used for local sightseeing, business travel, celebrations, and outstation journeys from Pune."
}
],
tableData: [
["Urbania on Rent for Corporate Travel Pune"],
["Urbania for Corporate Office Staff Pickup Pune"],
["Urbania Traveller for Corporate Events Pune"],
["Corporate Event Urbania Hire Pune"],
["Urbania for Corporate Group Travel Pune"],
["Luxury Urbania on Rent for Events Pune"],
["13 Seater Urbania on Rent in Pune"],
["13 Seater Urbania Traveller Pune"],
["13 Seater Urbania Hire in Pune"],
["13 Seater Urbania Booking Pune"],
["13 Seater Urbania Van on Rent Pune13 Seater Urbania for Outstation Pune"],
["13 Seater Urbania on Rent Near Me Pune"],
["13 Seater Luxury Urbania Rental Pune"],
["13 Seater Urbania for Family Trip Pune"],
["13 Seater Urbania for Group Travel Pune"]
],
whychoose: [
{
WhyChooseheading: "Spacious Transportation for Corporate Groups",
WhyChoosedescription: "Urbania vehicles provide a practical solution when several employees, guests, or business delegates need to travel together. The spacious seating arrangement helps keep corporate groups together and can reduce the coordination required when using multiple smaller cars."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Corporate travel often involves fixed meeting times, event schedules, airport transfers, and multiple pickup points. Professional driver support helps passengers focus on their work and travel plans while the transportation is handled according to the agreed itinerary."
},
{
WhyChooseheading: "Comfortable Travel for Long Journeys",
WhyChoosedescription: "For corporate events and outstation programs, passenger comfort becomes especially important during longer journeys. Air-conditioned Urbania vehicles with spacious seating offer a more convenient environment for employees and guests travelling together from Pune to other cities."
},
{
WhyChooseheading: "Suitable for Corporate Events",
WhyChoosedescription: "From conferences and seminars to annual functions, team outings, exhibitions, and business meetings, Urbania transportation can be planned around different corporate event requirements. The larger vehicle format makes group transfers easier to organize before and after the event."
},
{
WhyChooseheading: "Useful for Employee Transportation",
WhyChoosedescription: "Companies can use Urbania vehicles for staff pickup and drop, office transfers, employee gatherings, and group movements between business locations. This provides a centralized transportation option for teams travelling from different areas of Pune."
},
{
WhyChooseheading: "Convenient Airport and Railway Transfers",
WhyChoosedescription: "Corporate visitors and employees arriving through Pune International Airport or Pune Railway Station can travel together in one spacious vehicle. This is especially useful when passengers have luggage or are heading directly to offices, hotels, meeting venues, or corporate events."
},
{
WhyChooseheading: "Flexible Local and Outstation Usage",
WhyChoosedescription: "The Urbania can be arranged for short corporate transfers within Pune as well as longer outstation journeys. This flexibility makes it suitable for business meetings, company events, employee travel, group tours, and multi-location corporate schedules."
},
{
WhyChooseheading: "Organized Group Travel Experience",
WhyChoosedescription: "Ruturaj Enterprises focuses on making group transportation easier to coordinate by supporting planned pickup points, travel schedules, vehicle requirements, and destination transfers. A dedicated Urbania can help companies and groups maintain a more organized travel plan from departure to arrival."
}
]
};














const faqData = [
{
question: "How can companies hire an Urbania for corporate events in Pune?",
answer: "Companies can enquire about hiring an Urbania for corporate events by sharing the event venue, travel date, number of employees or guests, pickup locations, reporting time, and expected usage duration. Ruturaj Enterprises can discuss the vehicle arrangement according to conferences, seminars, annual functions, team outings, exhibitions, and other business events."
},
{
question: "Why is an Urbania suitable for corporate events in Pune?",
answer: "An Urbania can be a practical option for corporate groups that need to travel together in a spacious premium passenger vehicle. It can be used for employee transportation, executive groups, visiting clients, event delegates, and teams travelling between hotels, offices, conference venues, and other locations."
},
{
question: "Can Urbania be hired for corporate employee transportation in Pune?",
answer: "Organizations can arrange an Urbania for employees attending training programs, conferences, workshops, team-building activities, annual gatherings, and corporate celebrations. Pickup points, employee count, office locations, event venue, reporting time, and return schedule can be shared to plan transportation around the program."
},
{
question: "Can Ruturaj Enterprises provide Urbania for corporate conferences in Pune?",
answer: "Corporate organizers can enquire about Urbania transportation for conferences, seminars, product launches, exhibitions, workshops, and business meetings. The complete event schedule, venue address, participant count, pickup locations, and required vehicle timings can be provided so the transportation arrangement can be planned accordingly."
},
{
question: "Can an Urbania be used for transporting corporate clients and executives in Pune?",
answer: "An Urbania can be arranged for visiting clients, senior executives, management teams, consultants, and other professional guests when several passengers need to travel together. The itinerary may include airport pickup, hotel transfers, office visits, conference venues, and multiple business locations."
},
{
question: "Can I hire an Urbania for Pune corporate event airport transfers?",
answer: "Companies can use an Urbania for group transfers between Pune Airport, hotels, offices, and corporate event venues. Flight details, passenger count, luggage requirements, pickup location, and event reporting time can be shared with Ruturaj Enterprises while planning the airport transportation."
},
{
question: "Can Urbania rental be arranged for corporate team outings in Pune?",
answer: "Corporate teams planning outings, employee engagement programs, picnics, recreational trips, or team-building activities can enquire about Urbania rental. A dedicated group vehicle can help employees travel together between the office, meeting point, destination, and return location according to the planned itinerary."
},
{
question: "Can Urbania be hired for corporate events outside Pune?",
answer: "Companies can enquire about using an Urbania for corporate events and group journeys from Pune to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Kolhapur, Goa, and other locations. One-way, round-trip, and multi-day travel requirements can be discussed based on the event schedule."
},
{
question: "Can an Urbania handle transportation between hotels and event venues in Pune?",
answer: "Event organizers can arrange Urbania transportation for moving employees, delegates, clients, or guests between hotels and corporate venues. Multiple pickup points, scheduled reporting times, event sessions, and return trips can be included when discussing the transportation requirement with Ruturaj Enterprises."
},
{
question: "What details are required to hire an Urbania for a corporate event in Pune?",
answer: "Companies can provide the event date, venue address, passenger count, pickup locations, reporting time, expected rental duration, number of trips, and return schedule. Information about airport transfers, hotel transportation, multiple venues, employee groups, or outstation travel can also be shared when arranging the Urbania."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sameer Kulkarni",
feedback:
"Our company organized a corporate conference in Pune with employees coming from different office locations. We hired an Urbania from Ruturaj Enterprises for hotel and venue transfers. Having the team travel together made the event transportation much easier to coordinate, especially during the morning reporting and evening return schedules.",
rating: 5
},
{
id: 2,
name: "Miss. Priyanka Deshmukh",
feedback:
"We had a group of clients and senior employees visiting Pune for a business event. Ruturaj Enterprises arranged an Urbania for airport pickup, hotel transfer, and transportation to the conference venue. The larger vehicle was convenient for our group, and we were able to manage the complete event itinerary with one transportation arrangement.",
rating: 5
}
];

































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Events in Pune",
  "image": "https://ruturajenterprises.com/assets/images/urbania-hire-for-corporate-events-in-pune.webp",
  "description": "Urbania Hire for Corporate Events in Pune from Ruturaj Enterprises is a spacious and premium transportation option for companies, corporate teams, event organizers and business groups. Urbania on Rent for Corporate Travel Pune can be arranged for conferences, seminars, employee gatherings, corporate meetings, exhibitions and scheduled business travel. Urbania for Corporate Office Staff Pickup Pune is suitable for transporting employees and office teams comfortably, while Urbania Traveller for Corporate Events Pune and Corporate Event Urbania Hire Pune can support guest movement between offices, hotels, event venues and airports. Urbania for Corporate Group Travel Pune provides a practical solution for larger business groups, while Luxury Urbania on Rent for Events Pune adds a premium travel option for important corporate occasions. 13 Seater Urbania on Rent in Pune, 13 Seater Urbania Traveller Pune and 13 Seater Urbania Hire in Pune are suitable for companies and groups that require a spacious vehicle with professional driver service. 13 Seater Urbania Booking Pune and 13 Seater Urbania Van on Rent Pune can be arranged for local events as well as longer journeys. For intercity requirements, 13 Seater Urbania for Outstation Pune and 13 Seater Urbania on Rent Near Me Pune provide convenient options for corporate and group travel. The 13 Seater Luxury Urbania Rental Pune option is also suitable for executive groups, family functions and special events, while 13 Seater Urbania for Family Trip Pune and 13 Seater Urbania for Group Travel Pune can accommodate comfortable group transportation beyond regular corporate requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-hire-for-corporate-events-in-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>
    Urbania Hire for Corporate Events in Pune | 13 Seater Luxury Urbania for Business Groups | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania Hire for Corporate Events in Pune by Ruturaj Enterprises for corporate travel, office staff pickup, business events, group transportation, 13 seater Urbania rental, airport transfers and outstation trips."
  />

  <meta
    name="keywords"
    content="Urbania Hire for Corporate Events in Pune, Urbania on Rent for Corporate Travel Pune, Urbania for Corporate Office Staff Pickup Pune, Urbania Traveller for Corporate Events Pune, Corporate Event Urbania Hire Pune, Urbania for Corporate Group Travel Pune, Luxury Urbania on Rent for Events Pune, 13 Seater Urbania on Rent in Pune, 13 Seater Urbania Traveller Pune, 13 Seater Urbania Hire in Pune, 13 Seater Urbania Booking Pune, 13 Seater Urbania Van on Rent Pune, 13 Seater Urbania for Outstation Pune, 13 Seater Urbania on Rent Near Me Pune, 13 Seater Luxury Urbania Rental Pune, 13 Seater Urbania for Family Trip Pune, 13 Seater Urbania for Group Travel Pune, Urbania corporate cab Pune, Urbania corporate rental Pune, Urbania corporate travel Pune, Urbania for company events Pune, Urbania for business events Pune, Urbania for office transportation Pune, Urbania employee transportation Pune, Urbania corporate group cab Pune, Urbania corporate airport transfer Pune, Urbania for corporate meetings Pune, Urbania for conferences Pune, Urbania for seminars Pune, Urbania for exhibitions Pune, Urbania with driver for corporate Pune, luxury Urbania rental Pune, 13 seater Urbania with driver Pune, 13 seater Urbania corporate rental Pune, 13 seater Urbania for business travel Pune, 13 seater Urbania event transportation Pune, 13 seater Urbania airport transfer Pune, 13 seater Urbania corporate group travel Pune, 13 seater Urbania outstation rental Pune, Urbania van rental for corporate events Pune, Urbania traveller hire for company events Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforcorporateeverts;